import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useTheme } from '../../contexts/ThemeContext';
import TopMenu from './TopMenu';
import LeftSidebar from './LeftSidebar';
import RightAIPane from './RightAIPane';
import BottomNav from './BottomNav';
import './MainLayout.css';

type PanelType = 'chat' | 'notifications' | 'buy' | 'sell' | null;

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const { state: authState } = useAuth();
  const { state: themeState } = useTheme();
  const [leftSidebarCollapsed, setLeftSidebarCollapsed] = useState(false);
  const [rightPaneCollapsed, setRightPaneCollapsed] = useState(false);
  const [activePanel, setActivePanel] = useState<PanelType>(null);

  const toggleLeftSidebar = () => {
    setLeftSidebarCollapsed(!leftSidebarCollapsed);
  };

  const toggleRightPane = () => {
    setRightPaneCollapsed(!rightPaneCollapsed);
  };

  const handlePanelToggle = (panel: PanelType) => {
    if (activePanel === panel) {
      setActivePanel(null);
      setRightPaneCollapsed(true);
    } else {
      setActivePanel(panel);
      setRightPaneCollapsed(false);
    }
  };

  return (
    <div className={`main-layout ${themeState.isDark ? 'dark' : 'light'}`}>
      {/* Top Menu */}
      <TopMenu
        user={authState.user}
        onToggleLeftSidebar={toggleLeftSidebar}
        leftSidebarCollapsed={leftSidebarCollapsed}
      />

      {/* Main Content Area */}
      <div className="layout-body">
        {/* Left Sidebar */}
        <LeftSidebar
          collapsed={leftSidebarCollapsed}
          onToggle={toggleLeftSidebar}
        />

        {/* Main Content */}
        <main className="main-content">
          {children}
        </main>

        {/* Right Menu Bar */}
        <RightAIPane
          collapsed={rightPaneCollapsed}
          onToggle={toggleRightPane}
          activePanel={activePanel}
          onPanelToggle={handlePanelToggle}
        />
      </div>

      {/* Bottom Navigation (Mobile) */}
      <BottomNav
        activePanel={activePanel}
        onPanelToggle={handlePanelToggle}
      />
    </div>
  );
};

export default MainLayout;
